import { OperatorCreateEditController } from './operators-create-edit.directive.controller'

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { OperatorService, OPERATOR_CREATE_EDIT_SERVICE_NAME, OperatorCreateEditService } from '../../../../services/operator'

//#region Asset Imports

import * as TEMPLATE from './operators-create-edit.tpl.html'

//#endregion


//#region Setup

export class OperatorCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        OPERATOR_CREATE_EDIT_SERVICE_NAME, (
            $scope: any,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            operatorCreateEditService: OperatorCreateEditService
        ) => new OperatorCreateEditController(
            $scope,
            $q,
            $timeout,
            operatorCreateEditService,
            OperatorService.REFERENCE_TYPE,
            OperatorService.SIMAX_MODULE_NAME
        )]

    template = TEMPLATE
}

//#endregion